import { RemoteAdvertisingUpdate } from 'data/usecases';
import { AdvertisingUpdateUseCaseInterface } from 'domain/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeAdvertisingUpdate = (): AdvertisingUpdateUseCaseInterface =>
  new RemoteAdvertisingUpdate(makeApiUrlEntities(), makeAxiosHttpClient());
